/*
 * Full-screen product zoom, Row-style (snippets/aleo-pdp-zoom.liquid).
 * Scrolling through a vertical stack of full-width images is the
 * navigation -- this file wires: opening from a clicked gallery image
 * (jumping straight to it), the desktop thumbnail rail (click-to-jump,
 * highlight-the-one-in-view), color filtering (reusing the product
 * page's own galleryGroups data, not a second copy), and per-image
 * pinch/double-tap zoom on touch devices.
 */
(function () {
  function closest(el, selector) {
    return el.closest(selector);
  }

  function setupPinchZoom(imgWrap) {
    var img = imgWrap.querySelector('img');
    if (!img) return;

    var scale = 1;
    var panX = 0;
    var panY = 0;
    var pinchStartDistance = 0;
    var pinchStartScale = 1;
    var panStart = null;
    var lastTapTime = 0;
    var lastTapX = 0;
    var lastTapY = 0;

    function apply() {
      img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    }

    function clampPan() {
      var maxPanX = Math.max(0, (imgWrap.clientWidth * (scale - 1)) / 2);
      var maxPanY = Math.max(0, (imgWrap.clientHeight * (scale - 1)) / 2);
      panX = Math.min(maxPanX, Math.max(-maxPanX, panX));
      panY = Math.min(maxPanY, Math.max(-maxPanY, panY));
    }

    function reset() {
      scale = 1;
      panX = 0;
      panY = 0;
      apply();
      imgWrap.classList.remove('is-zoomed');
    }

    imgWrap.addEventListener(
      'touchstart',
      function (evt) {
        if (evt.touches.length === 2) {
          var dx = evt.touches[0].clientX - evt.touches[1].clientX;
          var dy = evt.touches[0].clientY - evt.touches[1].clientY;
          pinchStartDistance = Math.sqrt(dx * dx + dy * dy);
          pinchStartScale = scale;
        } else if (evt.touches.length === 1 && scale > 1) {
          panStart = { x: evt.touches[0].clientX - panX, y: evt.touches[0].clientY - panY };
        } else if (evt.touches.length === 1) {
          // Double-tap-to-zoom, only checked at rest (not while actively
          // panning a zoomed image, so a pan gesture can't misfire this).
          var now = Date.now();
          var t = evt.touches[0];
          if (now - lastTapTime < 300 && Math.abs(t.clientX - lastTapX) < 30 && Math.abs(t.clientY - lastTapY) < 30) {
            if (scale > 1) {
              reset();
            } else {
              scale = 2.5;
              apply();
              imgWrap.classList.add('is-zoomed');
            }
            lastTapTime = 0;
          } else {
            lastTapTime = now;
            lastTapX = t.clientX;
            lastTapY = t.clientY;
          }
        }
      },
      { passive: true }
    );

    imgWrap.addEventListener(
      'touchmove',
      function (evt) {
        if (evt.touches.length === 2) {
          evt.preventDefault();
          var dx = evt.touches[0].clientX - evt.touches[1].clientX;
          var dy = evt.touches[0].clientY - evt.touches[1].clientY;
          var dist = Math.sqrt(dx * dx + dy * dy);
          if (pinchStartDistance > 0) {
            scale = Math.max(1, Math.min(4, pinchStartScale * (dist / pinchStartDistance)));
            clampPan();
            apply();
            imgWrap.classList.toggle('is-zoomed', scale > 1);
          }
        } else if (evt.touches.length === 1 && panStart && scale > 1) {
          evt.preventDefault();
          panX = evt.touches[0].clientX - panStart.x;
          panY = evt.touches[0].clientY - panStart.y;
          clampPan();
          apply();
        }
        // Single finger, not zoomed: do nothing -- native vertical scroll
        // through the stack proceeds untouched.
      },
      { passive: false }
    );

    imgWrap.addEventListener('touchend', function () {
      panStart = null;
      pinchStartDistance = 0;
      if (scale < 1.05) reset();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var modal = document.getElementById('aleo-pdp-zoom-modal');
    if (!modal) return;

    var scrollEl = modal.querySelector('.aleo-pdp-zoom__scroll');
    var items = Array.prototype.slice.call(modal.querySelectorAll('[data-aleo-zoom-item]'));
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-aleo-zoom-thumb]'));

    items.forEach(function (item) {
      var wrap = item.querySelector('.aleo-pdp-zoom__img-wrap');
      if (wrap) setupPinchZoom(wrap);
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var target = items.filter(function (i) { return i.dataset.mediaId === thumb.dataset.mediaId; })[0];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    // Highlights whichever thumb matches the image currently most in
    // view, fades the rest -- threshold tuned so the item crossing the
    // vertical middle of the scroll area counts as "in view", not just
    // barely-visible at an edge.
    var activeMediaId = null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var mediaId = entry.target.dataset.mediaId;
          if (mediaId === activeMediaId) return;
          activeMediaId = mediaId;
          thumbs.forEach(function (thumb) {
            thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
          });
        });
      },
      { root: scrollEl, threshold: 0, rootMargin: '-45% 0px -45% 0px' }
    );
    items.forEach(function (item) { observer.observe(item); });

    // Color filtering -- reuses sections/product-page.liquid's own
    // galleryGroups JSON (keyed by media id -> { group, label, conflict }),
    // not a second copy of that computation.
    var galleryGroupsEl = document.querySelector('[id^="aleo-pdp-gallery-groups-"]');
    var galleryGroups = {};
    if (galleryGroupsEl) {
      try { galleryGroups = JSON.parse(galleryGroupsEl.textContent); } catch (e) { galleryGroups = {}; }
    }

    function filterToColor(colorValue) {
      if (!colorValue) return;
      var taggedForThisColor = items.filter(function (el) {
        var entry = galleryGroups[el.dataset.mediaId];
        return entry !== undefined && entry.group === colorValue;
      });
      var matchIds;
      if (taggedForThisColor.length) {
        var alwaysShown = items.filter(function (el) { return galleryGroups[el.dataset.mediaId] === undefined; });
        matchIds = taggedForThisColor.concat(alwaysShown).map(function (el) { return el.dataset.mediaId; });
      } else {
        matchIds = items.map(function (el) { return el.dataset.mediaId; });
      }
      items.forEach(function (el) { el.hidden = matchIds.indexOf(el.dataset.mediaId) === -1; });
      thumbs.forEach(function (el) { el.hidden = matchIds.indexOf(el.dataset.mediaId) === -1; });
    }

    function currentColorValue() {
      var checked = document.querySelector('.aleo-pdp__option--color .opt-btn:checked');
      return checked ? checked.value : null;
    }

    var colorFieldset = document.querySelector('.aleo-pdp__option--color');
    if (colorFieldset) {
      colorFieldset.addEventListener('change', function (evt) {
        if (!evt.target.classList.contains('opt-btn')) return;
        filterToColor(evt.target.value);
      });
    }

    document.addEventListener('click', function (evt) {
      var link = closest(evt.target, '.show-gallery');
      if (!link) return;
      evt.preventDefault();

      filterToColor(currentColorValue());

      var hrefUrl = link.getAttribute('href');
      var mediaId = link.closest('[data-media-id]') ? link.closest('[data-media-id]').dataset.mediaId : null;
      var target = mediaId ? items.filter(function (i) { return i.dataset.mediaId === mediaId; })[0] : null;

      modal.open(link);

      // Jump straight to the clicked image -- instant, not animated, so
      // opening doesn't visibly scroll past other images first.
      if (target) {
        var previousBehavior = scrollEl.style.scrollBehavior;
        scrollEl.style.scrollBehavior = 'auto';
        target.scrollIntoView({ block: 'start' });
        scrollEl.style.scrollBehavior = previousBehavior;
      }
    });
  });
})();
